import { jsx as _jsx } from "react/jsx-runtime";
import { ProgressCell } from "../components/RoomStatus/ProgressCell";
/**
 * 创建进度单元格渲染函数
 * @param dataSource - 数据源，用于计算最大 quantity
 * @returns 进度单元格渲染函数
 */
export var createProgressCellRender = function (dataSource) {
    // 全店行的 quantity = 所有房型 quantity 之和；作为换算基准（100 代表该值）
    // 灰色条：全店占满 100px，其余行 = (quantity / maxQuantity) * 100
    // 确保 maxQuantity 是所有行中 quantity 的最大值（通常是全店）
    var quantities = (dataSource === null || dataSource === void 0 ? void 0 : dataSource.map(function (r) { return r.quantity || 0; }).filter(function (q) { return q > 0; })) || [];
    var maxQuantity = quantities.length > 0 ? Math.max.apply(Math, quantities) : 1;
    return function (progress, record) { return (_jsx(ProgressCell, { progress: progress, quantity: record.quantity, quantityOpen: record.quantityOpen || 0, maxQuantity: maxQuantity, strokeColor: record.progressColor })); };
};
